(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["festive-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-festive-section]');
    if (!section) return;

    // ── Copy-to-clipboard (desktop) ──
    var copyBtn = section.querySelector('[data-festive-copy]');
    var feedback = section.querySelector('[data-festive-feedback]');
    if (copyBtn && feedback) {
      copyBtn.addEventListener('click', async function(e) {
        e.preventDefault();
        var code = this.getAttribute('data-code');
        try {
          await navigator.clipboard.writeText(code);
          feedback.classList.add('show');
          setTimeout(function() { feedback.classList.remove('show'); }, 1800);
        } catch (err) {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          feedback.classList.add('show');
          setTimeout(function() { feedback.classList.remove('show'); }, 1800);
        }
      });
    }

    // ── Copy-to-clipboard (mobile) ──
    var copyBtnM = section.querySelector('[data-festive-copy-mobile]');
    var feedbackM = section.querySelector('[data-festive-feedback-mobile]');
    if (copyBtnM && feedbackM) {
      copyBtnM.addEventListener('click', async function(e) {
        e.preventDefault();
        var code = this.getAttribute('data-code');
        try {
          await navigator.clipboard.writeText(code);
          feedbackM.classList.add('show');
          setTimeout(function() { feedbackM.classList.remove('show'); }, 1800);
        } catch (err) {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          feedbackM.classList.add('show');
          setTimeout(function() { feedbackM.classList.remove('show'); }, 1800);
        }
      });
    }

    // ── Countdown timer (desktop) ──
    var timer = section.querySelector('[data-festive-timer]');
    var display = section.querySelector('[data-festive-display]');
    var expired = section.querySelector('[data-festive-expired]');
    var daysEl = section.querySelector('[data-festive-days]');
    var hoursEl = section.querySelector('[data-festive-hours]');
    var minsEl = section.querySelector('[data-festive-mins]');
    var secsEl = section.querySelector('[data-festive-secs]');

    if (timer && display && expired && daysEl && hoursEl && minsEl && secsEl) {
      var endDateStr = timer.getAttribute('data-end');
      var expiredText = timer.getAttribute('data-expired-text') || 'SALE ENDED';
      if (endDateStr) {
        var endDate = new Date(endDateStr).getTime();
        if (!isNaN(endDate)) {
          function padTimer(n) { return String(n).padStart(2, '0'); }
          function tickTimer() {
            var diff = endDate - new Date().getTime();
            if (diff <= 0) {
              display.style.display = 'none';
              expired.style.display = 'inline';
              expired.textContent = expiredText;
              return;
            }
            daysEl.textContent = padTimer(Math.floor(diff / (1000 * 60 * 60 * 24)));
            hoursEl.textContent = padTimer(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            minsEl.textContent = padTimer(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
            secsEl.textContent = padTimer(Math.floor((diff % (1000 * 60)) / 1000));
          }
          tickTimer();
          setInterval(tickTimer, 1000);
        }
      }
    }

    // ── Countdown timer (mobile) ──
    var timerM = section.querySelector('[data-festive-timer-mobile]');
    var displayM = section.querySelector('[data-festive-display-mobile]');
    var expiredM = section.querySelector('[data-festive-expired-mobile]');
    var daysElM = section.querySelector('[data-festive-days-mobile]');
    var hoursElM = section.querySelector('[data-festive-hours-mobile]');
    var minsElM = section.querySelector('[data-festive-mins-mobile]');
    var secsElM = section.querySelector('[data-festive-secs-mobile]');

    if (timerM && displayM && expiredM && daysElM && hoursElM && minsElM && secsElM) {
      var endDateStrM = timerM.getAttribute('data-end');
      var expiredTextM = timerM.getAttribute('data-expired-text') || 'SALE ENDED';
      if (endDateStrM) {
        var endDateM = new Date(endDateStrM).getTime();
        if (!isNaN(endDateM)) {
          function padTimerM(n) { return String(n).padStart(2, '0'); }
          function tickTimerM() {
            var diff = endDateM - new Date().getTime();
            if (diff <= 0) {
              displayM.style.display = 'none';
              expiredM.style.display = 'inline';
              expiredM.textContent = expiredTextM;
              return;
            }
            daysElM.textContent = padTimerM(Math.floor(diff / (1000 * 60 * 60 * 24)));
            hoursElM.textContent = padTimerM(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            minsElM.textContent = padTimerM(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
            secsElM.textContent = padTimerM(Math.floor((diff % (1000 * 60)) / 1000));
          }
          tickTimerM();
          setInterval(tickTimerM, 1000);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
